import React, { useEffect } from "react";
import "./dltestimonials.css";
import profile1 from "../../../Assets/newAsset/TestiProfile.webp";
// import testimonialProfile from "../../../Assets/newAsset/testimonialProfile.jpeg";ss

import { useDispatch, useSelector } from "react-redux";
import { GET_TESTIMONIALS_REQUEST } from "../../../Redux/Constants";
import { testimonials, blogs } from "../../../Redux/Actions";
import Loader from "../../../components/Loader/Loader";
//importing CARASOUL
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { AiTwotoneStar } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";

//RESPONSIVE SCRREEN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1500 },
    items: 3,
  },
  smallDesktop: {
    breakpoint: { max: 1500, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 480 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 480, min: 0 },
    items: 1,
  },
};

function TestimonialNew() {
  //   const testimonalsdata = useSelector((state) => state.testimonials);
  //   const testimonialdata = testimonalsdata.testimonials;
  //   const { loading } = testimonalsdata;
  // console.log("testi data", testimonialdata);

  //   const dispatch = useDispatch();

  //   useEffect(() => {
  //     dispatch(testimonials());
  //   }, []);

  return (
    <React.Fragment>
      <>
        <div className="divHeading divHeadingTesti hideGoogle">
          <img
            width="100"
            height="auto"
            src={
              "https://staticcdn.redcliffelabs.com/media/gallary-file/None/4c598d17-aba3-4176-be09-4f969d445e83.png"
            }
            alt="google logo"
          />
          <h2>Reviews</h2>
          <div className="googleStats">
            <AiTwotoneStar />
            <span>4.7(7620+ Ratings)</span>
          </div>
        </div>
        {/* MOBILE VIEW FOR THE TESTIMONIAL */}
        <div className="divHeadingMob divHeadingTestiMob ">
          <div className="upperReview">
            <img
              width="100"
              height="auto"
              src={
                "https://staticcdn.redcliffelabs.com/media/gallary-file/None/4c598d17-aba3-4176-be09-4f969d445e83.png"
              }
              alt="google logo"
            />
            <h2>Reviews</h2>
          </div>
          <div className="googleStatsMob">
            <AiTwotoneStar />
            <span>4.7 (7620+ Ratings)</span>
          </div>
        </div>

        <Carousel
          swipeable={true}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2500}
          transitionDuration={200}
          deviceType={"tablet"}
        >
          <div className="Package__card Package__cardNeww Package__cardNewTesi bgOrdinary testiPackageHeight">
            <div className="testimonial__card">
              <div className="testimonial__cardHeader">
                <LazyLoadImage
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f74e630d-da6d-40ff-844b-ea3c4215db12.png"
                  alt="Profile logo"
                  delayTime="100"
                />
                <div className="card__headerUserDetails">
                  <span>
                    <span>Archana Tripathi</span>
                  </span>
                  <span>
                    <span>Vasant Kunj, 29</span>
                  </span>
                </div>
              </div>
              <div className="testimonial__cardTitle">
                <span>"Best Lab in Delhi"</span>
              </div>
              <div className="testimonial__cardFooter">
                <span></span>
                <span>
                  <div>
                    {/* {value.description.length > 250
                      ? `${value.description.substring(0, 250)}...`
                      : value.description} */}
                    The staff was supportive and helpful. The laboratory has
                    availability of advanced technology and equipment. My
                    experience at Redcliffe Imaging was good.
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div className="Package__card Package__cardNeww Package__cardNewTesi bgOrdinary testiPackageHeight">
            <div className="testimonial__card">
              <div className="testimonial__cardHeader">
                <LazyLoadImage
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f74e630d-da6d-40ff-844b-ea3c4215db12.png"
                  alt="Profile logo"
                  delayTime="100"
                />
                <div className="card__headerUserDetails">
                  <span>
                    <span>Garima Chaturvedi</span>
                  </span>
                  <span>
                    <span>Uttam Nagar, 35</span>
                  </span>
                </div>
              </div>
              <div className="testimonial__cardTitle">
                <span>"Great service!"</span>
              </div>
              <div className="testimonial__cardFooter">
                <span></span>
                <span>
                  <div>
                    {/* {value.description.length > 250
                      ? `${value.description.substring(0, 250)}...`
                      : value.description} */}
                    I visited Redcliffe Imaging for ultrasound. I went there on
                    an emergency basis and the staff treated me with utmost
                    care.
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div className="Package__card Package__cardNeww Package__cardNewTesi bgOrdinary testiPackageHeight">
            <div className="testimonial__card">
              <div className="testimonial__cardHeader">
                <LazyLoadImage
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f74e630d-da6d-40ff-844b-ea3c4215db12.png"
                  alt="Profile logo"
                  delayTime="100"
                />
                <div className="card__headerUserDetails">
                  <span>
                    <span>Junaid khan</span>
                  </span>
                  <span>
                    <span>Old JNU, 30</span>
                  </span>
                </div>
              </div>
              <div className="testimonial__cardTitle">
                <span>"Amazing experience"</span>
              </div>
              <div className="testimonial__cardFooter">
                <span></span>
                <span>
                  <div>
                    {/* {value.description.length > 250
                      ? `${value.description.substring(0, 250)}...`
                      : value.description} */}
                    The services at Redcliffe Imaging are good and waiting time
                    is less as compared to other labs nearby. The medical team
                    and other staff are friendly.
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div className="Package__card Package__cardNeww Package__cardNewTesi bgOrdinary testiPackageHeight">
            <div className="testimonial__card">
              <div className="testimonial__cardHeader">
                <LazyLoadImage
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f74e630d-da6d-40ff-844b-ea3c4215db12.png"
                  alt="Profile logo"
                  delayTime="100"
                />
                <div className="card__headerUserDetails">
                  <span>
                    <span>Rahul Sharma</span>
                  </span>
                  <span>
                    <span>Vikas Puri, 25</span>
                  </span>
                </div>
              </div>
              <div className="testimonial__cardTitle">
                <span>"Cost-effective"</span>
              </div>
              <div className="testimonial__cardFooter">
                <span></span>
                <span>
                  <div>
                    {/* {value.description.length > 250
                      ? `${value.description.substring(0, 250)}...`
                      : value.description} */}
                    The prices of imaging procedures at Redcliffe Labs are
                    affordable than other labs. Apart from the clean labs, I am
                    amazed by their delivery of super fast reports.
                  </div>
                </span>
              </div>
            </div>
          </div>
        </Carousel>
      </>
    </React.Fragment>
  );
}

export default TestimonialNew;
